<template>
  <div class="settings-client-dropdown">
    <v-dropdown ref="dropdown" width-auto position-right>
      <v-btn icon :loading="loading" @click="onClick">
        <v-icon font-size="1.2" icon="cog"></v-icon>
      </v-btn>

      <div v-if="loaded" slot="content" class="settings-client-dropdown__content">
        <v-card elevated>
          <div class="user-params">
            <h2 class="card-title mb-3">{{ 'activities.user_params' | translate }}</h2>
            <button @click="closeDropdown()" class="v-dialog-close"><i class="i-util-close"></i></button>
          </div>
          <v-card-content>
            <v-switch class="mb-3" :label="$t('activities.access_kkz')" v-model="form.kkz" @input="update"></v-switch>
            <v-switch class="mb-3" :label="$t('activities.activate_client')" v-model="form.is_active" @input="update"></v-switch>
          </v-card-content>
          <div class="card-title-dia">
            <h2 class="card-title mb-3">{{ 'base.action' | translate }}</h2>
          </div>

          <v-card-actions>
            <div class="settings-client-dropdown__group">
              <v-btn small ghost @click="editClick">
                <v-icon position-left font-size="1" icon="pencil-alt"></v-icon>
                <span>{{ this.$t('activities.edit') }}</span>
              </v-btn>
            </div>

            <div class="settings-client-dropdown__group">
              <v-btn ghost small @click="changeClick">
                <v-icon position-left font-size="1" icon="key"></v-icon>
                <span>{{ 'auth.changes_password' | translate }}</span>
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </div>
    </v-dropdown>
  </div>
</template>


<script>
import { mapActions, mapGetters } from 'vuex'
import DeleteBtn from '@/components/common/delete-btn/DeleteBtn'

export default {
  name: 'SettingsClientDropdown',

  components: {
    DeleteBtn
  },

  props: {
    id: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    form: {
      profeed: false,
      kkz: false,
      is_active: false
    },
    client: null,
    loading: false,
    loaded: false
  }),

  computed: {
    ...mapGetters('dashboard', [
      'currentUser'
    ])
  },

  methods: {
    ...mapActions('dashboard', [
      'getUser',
      'updateUser'
    ]),

    async onClick () {
      this.loaded = false
      this.loading = true
      await this.getUser(this.id)
      this.form.is_active = this.currentUser.is_active
      this.form.profeed = this.currentUser.modules.some(item => item === 'profeed')
      this.form.kkz = this.currentUser.modules.some(item => item === 'animalfeed')
      this.loaded = true
      this.loading = false
    },

    async update () {
      this.loading = true
      const payload = {
        id: this.currentUser.id,
        email: this.currentUser.email,
        first_name: this.currentUser.first_name,
        last_name: this.currentUser.last_name,
        phone: this.currentUser.phone,
        user_type: this.currentUser.user_type,
        is_active: this.form.is_active,
        profile: {
          about: this.currentUser.profile.about,
          language: this.currentUser.profile.language,
          group: this.currentUser.profile.group
        },
        modules: []
      }
      if (this.form.profeed) {
        payload.modules.push('profeed')
      }
      if (this.form.kkz) {
        payload.modules.push('animalfeed')
      }
      await this.updateUser(payload)
      this.loading = false
    },

    editClick () {
      this.$emit('edit')
    },
    changeClick () {
      this.$emit('change')
    },
    closeDropdown () {
      this.$refs.dropdown.closeDropdown()
      this.loaded = false
    }
  }
}
</script>

<style lang="scss" scoped>
.v-dialog-close {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  z-index: 5;
  top: 1rem;
  right: 1rem;
  width: 3.6rem;
  height: 3.6rem;
  border-radius: 1rem;
  background-color: #eee;
  transition: .3s linear;
  i {
    transform: scale(0.6);
  }
}

.user-params {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.5rem 2rem;
  border-bottom: 1px solid #D7D7D7;

  h2 {
    margin-bottom: 0 !important;
  }
}

.card-title-dia {
  padding: 1.5rem 2rem;
  border-top: 1px solid #D7D7D7;

}

.settings-client-dropdown {
  &__content {
    width: 38rem;
  }

  &__group:not(:last-child) {
    margin-bottom: 2rem;
  }
}
</style>
